import React, { ClipboardEvent } from 'react';
import env from '.env.json';

function DisableCopy({ children }) {
  const handleCopy = (e: ClipboardEvent) => {
    if (env.ENV === 'prod') {
      e.clipboardData?.setData("text/plain", "Copying is not allowed on this webpage");
      e.preventDefault();
    }
  };

  return (
    <div
      onCopy={handleCopy}
      onCut={handleCopy}
    >
      {children}
    </div>
  );
}

export default DisableCopy;
